import { render, staticRenderFns } from "./otherPrice.vue?vue&type=template&id=d9b4fee6&scoped=true&"
import script from "./otherPrice.vue?vue&type=script&lang=js&"
export * from "./otherPrice.vue?vue&type=script&lang=js&"
import style0 from "./otherPrice.css?vue&type=style&index=0&id=d9b4fee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b4fee6",
  null
  
)

export default component.exports